export interface IEtiqueta {
   cpf: string;
   texto: string;
   numero: number;
}


export class TAG_NENHUMA_ETIQUETA implements IEtiqueta {
   texto: string = '-Nenhuma etiqueta-';
   numero: number = -1;
   cpf: string;
}

export class TAG_ALGUMA_ETIQUETA implements IEtiqueta {
   texto: string = '-Pelo menos uma etiqueta-';
   numero: number = -2;
   cpf: string;
}

export class EtiquetaOrigem {
   id: number;
   nome: string;
   isEtiqueta: boolean;
}
